export const formatSizeUnits = (bytes: number) => {
  if (bytes >= 1e9) {
    return (bytes / 1e9).toFixed(2) + ' GB';
  }

  if (bytes >= 1e6) {
    return (bytes / 1e6).toFixed(2) + ' MB';
  }

  if (bytes >= 1e3) {
    return (bytes / 1e3).toFixed(2) + ' kB';
  }

  return bytes > 1 ? bytes + ' bytes' : bytes === 1 ? '1 byte' : '0 bytes';
};
